export enum LANGUAGE_CODE {
  EnglishUS = 0,
  FrenchFR = 2,
  DutchBE = 5,
  GermanDE = 6
}
